import { ActionReducer, MetaReducer } from '@ngrx/store';
import { utilLocalStorageReducer } from '@medlogic/shared/utils';
import { initialStateTutorial } from './tutorial.reducer';
import {
  loadTutorials,
  loadTutorialsSuccess,
  loadTutorialsFailure
} from './tutorial.actions';

const KEY = 'MEDLOGIC_TUTORIAL_STATE';

// Includes the action types that must be persisted.
const PERSISTED_ACTIONS: string[] = [
  loadTutorials,
  loadTutorialsSuccess,
  loadTutorialsFailure
].map(m => m.type.toString());

export function localStorageReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return utilLocalStorageReducer(reducer, PERSISTED_ACTIONS, KEY, initialStateTutorial);
}

export const metaReducers: MetaReducer<any>[] = [localStorageReducer];
